import {
  FeedbackProvider,
  MarketDataProvider,
  ReferralProvider,
} from '@/components/providers';
import { ReactNode } from 'react';
import { AuthorizationProvider } from './AuthorizationProvider';
import { NewsProvider } from './NewsProvider';
import { RoadmapProvider } from './RoadmapProvider';
import { TradeableTokensProvider } from './TradeableTokensProvider';
import { UserTransactionsProvider } from './UserTransactionsProvider';
import { UserWalletsProvider } from './UserWalletsProvider';
import { YieldBearingAssetsProvider } from './YieldBearingAssetsProvider';
interface ProvidersWrapperProps {
  children: ReactNode;
}
const PostAuthProvidersWrapper = ({
  children,
}: ProvidersWrapperProps): JSX.Element => (
  <AuthorizationProvider>
    <FeedbackProvider>
      <UserWalletsProvider>
        <ReferralProvider>
          <YieldBearingAssetsProvider>
            <UserTransactionsProvider>
              <NewsProvider>
                <MarketDataProvider>
                  <TradeableTokensProvider>
                    <RoadmapProvider>{children}</RoadmapProvider>
                  </TradeableTokensProvider>
                </MarketDataProvider>
              </NewsProvider>
            </UserTransactionsProvider>
          </YieldBearingAssetsProvider>
        </ReferralProvider>
      </UserWalletsProvider>
    </FeedbackProvider>
  </AuthorizationProvider>
);
export default PostAuthProvidersWrapper;
